import { render } from "./ProjectsGridPage.vue?vue&type=template&id=6118e1b8&ts=true"
import script from "./ProjectsGridPage.vue?vue&type=script&lang=ts"
export * from "./ProjectsGridPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__